import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { updateVerificationRuleMutation } from "mutations/verificationRuleMutations";
import { Query } from "react-apollo";
import { showIndex } from "utils/navigation";
import { notifications } from "@zendesk/knowledge-components/lib/Notifications/Connected";
import MutationWithOverlay from "components/MutationWithOverlay";
import t from "@zendesk/client-i18n-tools";
import prepareFilters from "utils/prepareFilters";
import gql from "graphql-tag";

const dirtyStateQuery = gql`
  query {
    dirtyState @client {
      ruleName
      frequency
      filters {
        type
        value
      }
      notificationRecipient
    }
  }
`;

export default class UpdateVerificationRuleMutation extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
  };

  onUpdated = ({ updateVerificationRule: { success } }) => {
    if (success) {
      showIndex({ skipDirtyCheck: true });
      notifications.showSuccess({
        message: t(
          "knowledge-verification.notification.verificationRuleUpdate.message"
        ),
      });
    } else {
      notifications.showError({
        message: t(
          "knowledge-verification.notification.verificationRuleUpdate.failed"
        ),
      });
    }
  };

  render() {
    const { children, id } = this.props;

    return (
      <Query query={dirtyStateQuery}>
        {({ data: { dirtyState } }) => (
          <MutationWithOverlay
            mutation={updateVerificationRuleMutation}
            refetchQueries={["verificationRules", "VerificationRule"]}
            variables={{
              id,
              name: dirtyState.ruleName,
              filter: prepareFilters(dirtyState.filters),
              frequency: dirtyState.frequency,
              notification: {
                recipient: dirtyState.notificationRecipient,
              },
            }}
            awaitRefetchQueries
            onCompleted={this.onUpdated}
          >
            {children}
          </MutationWithOverlay>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UpdateVerificationRuleMutation/index.js